import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-138afadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "crm-item__left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-folder project-icon" })
], -1))
const _hoisted_2 = { class: "crm-item__body" }
const _hoisted_3 = { class: "crm-item__title" }
const _hoisted_4 = { class: "crm-item__text" }
const _hoisted_5 = { class: "crm-item__right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-link" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "crm-item__container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(!_ctx.isLinked ? 'linkToProject' : 'navigateToMobiCRM', _ctx.project.id)))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.project.name), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.project.statusLabel), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.isLinked)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            content: _ctx.$t('ProjectPreview.AssociateTooltip'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["content"]))
        : (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 1,
            content: _ctx.$t('ProjectPreview.AlreadyAssociatedTooltip'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["content"]))
    ])
  ]))
}